import { memo } from 'react'
import { areEqual } from 'react-window'
import classNames from 'classnames'
import LogoImage from '@/images/icons/logo/logo-mini.svg?react'
import FullLogoImage from '@/images/icons/logo/logo.svg?react'
import styles from './Logo.module.scss'

interface LogoProps {
  className?: string
  full?: boolean
}

const Logo = ({ className, full }: LogoProps) => {
  return <span className={classNames(styles.logoContainer, className)}>
    {!full && <LogoImage className={styles.logo}/>}
    {full && <FullLogoImage className={styles.fullLogo}/>}
  </span>
}

export default memo(Logo, areEqual)
